import { env } from 'env';

const STATIC_WEBSITE_URL = 'https://pergam.in';
const SERVICE_DESK_STATIC_URL =
  'https://pergamin.atlassian.net/servicedesk/customer/portal/5/article';

// Asseco SimplySign account/certificate management portal — where users manage
// or buy their qualified certificate when none is installed. The backend
// (AssecoServiceProvider) binds the SimplySign tenant to production only on the
// production environment and to the "model" (test) tenant everywhere else, so
// mirror that here — otherwise dev/test users would be sent to a portal where
// their account doesn't exist. Production is detected via a direct comparison
// against the production API URL (single prod tenant); this is the same signal
// CertificateInstructionModal keys off, though that file uses a fuller URL→URL
// map rather than this binary check.
const PRODUCTION_API_URL = 'https://api.pergam.in';
const SIMPLY_SIGN_PORTAL_URL =
  env.REACT_APP_API_URL === PRODUCTION_API_URL
    ? 'https://cloudsign.webnotarius.pl/ccm/welcome'
    : 'https://model.simplysign.webnotarius.pl/ccm/welcome';

export const STATIC_URLS = {
  contact: `${STATIC_WEBSITE_URL}/konsultacje`,
  help: `${STATIC_WEBSITE_URL}/help-center`,
  privacyPolicy: `${STATIC_WEBSITE_URL}/polityka-prywatnosci-aplikacji`,
  signTypes: `${SERVICE_DESK_STATIC_URL}/237043937`,
  simplySignPortal: SIMPLY_SIGN_PORTAL_URL,
  staticWebsiteUrl: STATIC_WEBSITE_URL,
  templateCreator: `${SERVICE_DESK_STATIC_URL}/237011471`,
  termsAndConditions: `${STATIC_WEBSITE_URL}/regulamin`,
  transactionApi: `${STATIC_WEBSITE_URL}/transaction-api`,
} as const;
